import { __decorate } from "tslib";
import { cloneDeep } from "lodash-es";
import { FITDATAIDS } from "../fitData/consts";
import { State } from 'vue-class-state';
import { BaseState } from "../state/BaseState";
import { StateDefine } from "../state/utils/StateDefine";
import { getAllDataSchema, getListDataSchema, getListDataWithStatusSchema, getSelectedItemsSchema, getProdListDataSchema, getDeleteOpListDataSchema, getHistoryListDataSchema, pageSchema, sizeSchema, totalSchema, prodCountSchema, deleteOpCountSchema, historyCountSchema, prodPageSchema, prodSizeSchema, deleteOpSizeSchema, deleteOpPageSchema, historyPageSchema, historySizeSchema, publishStatusFilterSchema } from "../stateCommon/list";
import { bodyFilterField, bodySortField } from "../templates/apis/list";
import { NotEnumerable } from "../../tools/enumerable";
import { StateProxy } from "./utils/defineProxyState";
export class RvListStateJS extends BaseState {
  constructor(collection, options) {
    super(collection, options);
    this.fitDataId = FITDATAIDS.rvListJS;
    this.stateModel = 'rv_list_JS';
    this.ucTag = '支持行级版本管理的列表';
    /**
     * 给本地分页使用的，存放所有数据
     */
    this.allData = [];
    this.listData = [];
    this.page = 1;
    this.size = 20;
    this.filter = [];
    this.publishStatusFilter = 0;
    this.sort = [];
    this.total = 0;
    this.selectedItems = [];
    this.listDataWithStatus = [];
    this.prodListData = [];
    this.prodPage = 1;
    this.prodSize = 20;
    this.prodCount = 0;
    this.deleteOpListData = [];
    this.deleteOpCount = 0;
    this.deleteOpPage = 1;
    this.deleteOpSize = 20;
    this.historyListData = [];
    this.historyCount = 0;
    this.historyPage = 1;
    this.historySize = 20;
    this.initState();
  }
}
RvListStateJS.stateModel = 'rv_list_JS';
__decorate([StateDefine(getAllDataSchema), NotEnumerable], RvListStateJS.prototype, "allData", void 0);
__decorate([StateDefine(getListDataSchema(false)), StateProxy], RvListStateJS.prototype, "listData", void 0);
__decorate([StateDefine(pageSchema), State], RvListStateJS.prototype, "page", void 0);
__decorate([StateDefine(sizeSchema), State], RvListStateJS.prototype, "size", void 0);
__decorate([StateDefine(() => {
  const schema = cloneDeep(bodyFilterField);
  return schema;
}), State], RvListStateJS.prototype, "filter", void 0);
__decorate([StateDefine(publishStatusFilterSchema), State], RvListStateJS.prototype, "publishStatusFilter", void 0);
__decorate([StateDefine(bodySortField), State], RvListStateJS.prototype, "sort", void 0);
__decorate([StateDefine(totalSchema), State], RvListStateJS.prototype, "total", void 0);
__decorate([StateDefine(getSelectedItemsSchema), State], RvListStateJS.prototype, "selectedItems", void 0);
__decorate([StateDefine(getListDataWithStatusSchema), StateProxy], RvListStateJS.prototype, "listDataWithStatus", void 0);
__decorate([StateDefine(getProdListDataSchema), StateProxy], RvListStateJS.prototype, "prodListData", void 0);
__decorate([StateDefine(prodPageSchema), State], RvListStateJS.prototype, "prodPage", void 0);
__decorate([StateDefine(prodSizeSchema), State], RvListStateJS.prototype, "prodSize", void 0);
__decorate([StateDefine(prodCountSchema), State], RvListStateJS.prototype, "prodCount", void 0);
__decorate([StateDefine(getDeleteOpListDataSchema), State], RvListStateJS.prototype, "deleteOpListData", void 0);
__decorate([StateDefine(deleteOpCountSchema), State], RvListStateJS.prototype, "deleteOpCount", void 0);
__decorate([StateDefine(deleteOpPageSchema), State], RvListStateJS.prototype, "deleteOpPage", void 0);
__decorate([StateDefine(deleteOpSizeSchema), State], RvListStateJS.prototype, "deleteOpSize", void 0);
__decorate([StateDefine(getHistoryListDataSchema), StateProxy], RvListStateJS.prototype, "historyListData", void 0);
__decorate([StateDefine(historyCountSchema), State], RvListStateJS.prototype, "historyCount", void 0);
__decorate([StateDefine(historyPageSchema), State], RvListStateJS.prototype, "historyPage", void 0);
__decorate([StateDefine(historySizeSchema), State], RvListStateJS.prototype, "historySize", void 0);
//# sourceMappingURL=RvListStateJS.js.map
